module.exports = __webpack_public_path__ + "static/media/screen-linkedin-nodon.6a7df22f.png";